import { useState } from 'react';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { prompt: '' };

// Teacher writes the task description here - the student's platform side
// shows this prompt above a large free-text answer area (not editable from
// this side at all, per the exercise-templates convention: the constructor
// only ever configures the QUESTION, never simulates or stores an answer).
export default function EssayEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [prompt, setPrompt] = useState(initial.prompt || '');

   const handleSave = () => onSave({ text: prompt, config: JSON.stringify({ prompt }) });

   return (
      <div className='exercise-block-generic-editor'>
         <RichTextEditor rows={4} value={prompt}
            placeholder='Опис завдання для студента, напр: Опишіть свій типовий робочий день англійською (5-7 речень)'
            onChange={setPrompt} />
         <p className='exercise-block-hint-text'>Студент побачить цей опис і велике поле для вільної текстової відповіді.</p>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderEssayPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.prompt) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   return <p className='exercise-block-text-preview'>{renderRichText(cfg.prompt)}</p>;
}
